<template>
    <footer>
        <div id="check-footer" class="ext">
            <div class="int">
                <div class="line mobile help">
                    <p><b>Dúvidas?</b> Entre em contato:</p>
                    <p><span>SAC:</span> 31 3235 8200 / <span>EMAIL:</span> sac@lavillecasa.com.br</p>
                </div>
                <div class="line">
                    <div class="col50">
                        <h4>Formas de pagamento</h4>
                        <div class="box type-payment">
                            <img src="https://www.lavillecasa.com.br/arquivos/check-bandeiras.png" alt="Visa, MasterCard, Amex, Dinners">
                        </div>
                    </div>
                    <div class="col50 ">
                        <h4>Segurança</h4>
                        <div class="box certificate">
                            <img src="https://www.lavillecasa.com.br/arquivos/check-digicert.png" alt="Digicert">
                        </div>
                    </div>
                </div>
            </div>
            <div id="check-legal" class="ext">
                <div class="int">
                    <p>Nossas Lojas: LA VILLE LOURDES - Av. Bias Fortes, 274 - Lourdes - BH - MG - Seg. à Sex: 9h às 19h | Sábado: 09h às 16h - LA VILLE PONTEIO LAR SHOPING - Belvedere - 2º Piso - BH - MG - Seg. á Sábado: 10h às 22h | Domingo: 14h às 20h – LA VILLE BH SHOPPING - Rodovia BR-356, 3049 – Belvedere - BH - MG - Seg. á Sábado: 10h às 22h | Domingo: 14h às 20h - LA VILLE - TELEVENDAS - Seg. à Sex: 7h às 20h | Sábado e Domingo: 8h às 15h - (31) 3235-8200. CNPJ SITE LA VILLE: 05.529.117/0007-76</p>
                </div>
            </div>
        </div>
    </footer>
</template>
